import { Component, Inject } from '@angular/core';
import { AbstractModal } from '../abstract-modal/abstract-modal';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DateService } from '@aiwyn/shared';

@Component({
  selector: 'app-cannot-delete-payment-method',
  templateUrl: './cannot-delete-payment-method.component.html',
  styleUrls: ['./cannot-delete-payment-method.component.scss'],
  standalone: false,
})
export class CannotDeletePaymentMethodComponent extends AbstractModal {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { isUsedByAutomaticPayments: boolean, isUsedByEngagements: boolean, isUsedByPendingPayments: boolean },
    public dialogRef: MatDialogRef<CannotDeletePaymentMethodComponent>) {
    super(dialogRef);
  }

  /**
   * Close the modal.
   */
  onClose(): void {
    this.dialogRef.close();
  }

  /**
   * Get support email address.
   */
  // TODO JER can we extract this function into a service? Looks like it is used in several places.
  getEmail(): string {
    const subdomain =  window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;
    return 'mailto:support@aiwyn.ai?subject=Error%20encountered&body=%0D%0A-----------------------------------------%0D%0APlace message above this line %0D%0AClient: ' + subdomain + ' %0D%0ATime: ' + DateService.getIsoDateTime();
  }
}
